import CONST from './Constant';
import axiosPrivate from '../../../../Setup/Axios/SetupAxios';
import {handleAsyncAction} from '../../../../Setup';

export const initialize = (payload) => ({
    type: CONST.INITIALIZE,
    payload,
});

export const setConfig = (payload) => ({
    type: CONST.SET_CONFIG,
    payload,
});

export const setMode = (payload) => ({
    type: CONST.SET_MODE,
    payload,
});

export const setAppBarHeight = (payload) => ({
    type: CONST.SET_APPBAR_HEIGHT,
    payload,
})

export const setActiveMenu = (payload) => ({
    type: CONST.SET_ACTIVE_MENU,
    payload,
})

export const setBlockUI = (payload) => ({
    type: CONST.BLOCKUI_STATE,
    payload,
})

export const setModal = (payload) => ({
    type: CONST.SET_MODAL,
    payload,
})

export const setLeftDrawer = (payload) => ({
    type: CONST.SET_LEFT_DRAWER,
    payload,
})

export const setRightDrawer = (payload) => ({
    type: CONST.SET_RIGHT_DRAWER,
    payload,
})


/****************************************
 *  Fetch App Config
 ****************************************/
// Fetch Features
export const fetchAppConfigSuccess = (payload) => ({
    type: CONST.FETCH_CONFIG_SUCCESS,
    payload,
});

export const fetchAppConfigFailed = (payload) => ({
    type: CONST.FETCH_CONFIG_FAILED,
    payload,
});

export const fetchAppConfig = ({ dispatch }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/app/config'),
        [fetchAppConfigSuccess],
        fetchAppConfigFailed
    );
}

/****************************************
 Preview Theme
 ****************************************/
export const previewTheme = (payload) => ({
    type: CONST.PREVIEW_THEME,
    payload: payload
})

/****************************************
 Restore Theme
 ****************************************/
export const restoreTheme = () => ({
    type: CONST.RESTORE_THEME,
})

/****************************************
 Set Theme
 ****************************************/
export const setTheme = (payload) => ({
    type: CONST.SET_THEME,
    payload: payload
})